import { moduleProviderFactory } from 'core/providers';
import { ProcedureCodeList, ProcedureCodeEdit, ProcedureCodeUpload } from 'application/procedure-code/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.procedure-code',
                pattern: '/procedure-code',
                children: [
                    {
                        name: 'master.app.main.procedure-code.list',
                        pattern: '',
                        tabTitle: 'PROCEDURE_CODE.LIST.TITLE',
                        component: ProcedureCodeList,
                        data: {
                            title: 'PROCEDURE_CODE.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.procedure-code.create',
                        pattern: '/create',
                        tabTitle: 'PROCEDURE_CODE.CREATE.TITLE',
                        component: ProcedureCodeEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PROCEDURE_CODE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.procedure-code.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'PROCEDURE_CODE.EDIT.TITLE',
                        component: ProcedureCodeEdit,
                        data: {
                            title: 'PROCEDURE_CODE.EDIT.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.procedure-code.upload',
                        pattern: '/upload',
                        tabTitle: 'PROCEDURE_CODE.UPLOAD.TITLE',
                        component: ProcedureCodeUpload,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PROCEDURE_CODE.UPLOAD.TITLE'
                        },
                    }          
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.PROCEDURE_CODES',
                        route: 'master.app.main.procedure-code.list',
                        order: 9.1,
                    }                    
                ]
            }
        ]
    });
})();

